import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from "../../src/context/AuthContext";
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const TwoFactorPage = ({ portalSettings }) => {
    //State Variables
    const [code, setCode] = useState('');
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token'); 

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Two Factor`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        const res = await fetch(`${apiURL}/account/VerifyTwoFactorToken`, {
            method: 'POST',
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, token }),
        });

        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            alert(errorData.message || 'Login failed.');
            return;
        }

        const data = await res.json();

        switch (data.result.resultType) {
            case 0:
                login();
                navigate('/home'); 
                break;
            case 3:
                alert('Server Error');
                break;
            case 4:
                alert('InvalidTwoFactorToken');
                break;
            case 5:
                alert('ExpiredTwoFactorToken');
                break;
            default:
                alert('Unexpected response from server.');
                break;
        }
    }; 

    return (
        <div className="auth-page">
            <EmptyHeader/>
            <EmptyHeader/>
            <EmptyHeader/>
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Login</h2>
                <form className="baseForm" onSubmit={handleLogin}>
                    <label className="baseLabel">Two Factor Code</label>
                    <input className="baseInput" value={code} onChange={(e) => setCode(e.target.value)} required />
                    <button className="baseButton" type="submit">Login</button>
                </form>

            </div>
        </div>
    );
};

export default TwoFactorPage;
